import React, {useState} from 'react';
import {AiAssistantChatbot} from '../../../../modules/AiAssistantChatbot';

interface Props {
  onCloseChatbot: () => void;
}

const AssistantChatbotWrapper = React.memo(({onCloseChatbot}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="AssistantChatbotWrapper">
      <AiAssistantChatbot
        onClosed={() => setIsOpen(false)}
        onOpened={() => setIsOpen(true)}
      />
      {isOpen ? (
        <button className="OpenerButton" onClick={onCloseChatbot}>
          <span className={'icon-plus'}></span>
        </button>
      ) : null}
    </div>
  );
});

export default AssistantChatbotWrapper;
